// Hungarian attaches suffixes to numbers and abbreviations with a hyphen
// ("0%-os", "kkv-knak", "30-ig"). A browser may break the line at that hyphen,
// leaving the suffix alone on the next line. Swap such hyphens for a
// non-breaking hyphen (U+2011) when the part after it is a short suffix or
// number ("A-24").
// Display only: page titles and metadata keep the plain hyphen.
const SUFFIX_HYPHEN = /(\S)-([\p{L}\p{N}]{1,4})(?=$|[\s,.;:!?)])/gu;

export const keepSuffixes = (text) => String(text || "").replace(SUFFIX_HYPHEN, "$1\u2011$2");
